module.exports = __webpack_public_path__ + "media/images/pic/cosmos-956ae8072f4ba2857cedd6e800c5183b.jpeg";